import { makeStyles } from 'tss-react/mui';
import { COLORS } from '../../constants/system/colors';

const useStylesOktaButton: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  oktaButton: {
    width: 200,
    backgroundColor: `${COLORS.oktaBackground} !important`,
    borderRadius: '5px !important',
    color: `${theme.palette.common.white} !important`,
    '& > svg': {
      maxWidth: 24,
      maxHeight: 24,
      color: `${theme.palette.common.white} !important`,
    },
    '& > span:first-of-type': {
      marginTop: 2,
      marginLeft: 7,
    },
  },
}));

export default useStylesOktaButton;
